import { Tooltip as AntTooltip } from 'antd'
import { TooltipProps } from 'antd/es/tooltip'
import React from 'react'

export const DatacTooltip: React.FC<TooltipProps> = props => (
  <AntTooltip placement="topLeft" mouseEnterDelay={0.3} {...props}>
    {props.children}
  </AntTooltip>
)
